import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=7a3a81f8&scoped=true&"
import script from "./PlusIcon.vue?vue&type=script&lang=js&"
export * from "./PlusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a81f8",
  null
  
)

export default component.exports